import { Grid, Box } from '@mui/material';
import { ReactNode } from 'react';

import WhistleSidebar from '../../whistleblower/sidebar/whistleSidebar';

interface ParentComponentProps {
  isSideBarOpen: boolean;
  center: ReactNode;
}

const KnowledgeBaseLayout = ({ isSideBarOpen, center }: ParentComponentProps) => {
  return (
    <Box flexGrow={1} display='flex' width='100%' bgcolor='#EEE'>
      <WhistleSidebar isOpenMobile={isSideBarOpen} />
      <Box
        flexGrow={1}
        pl={6}
        pr={6}
        pt={3}
        pb={6}
        display='flex'
        flexDirection={{ xs: 'column', sm: 'row' }}
      >
        <Grid container item>
          <Grid item xs={12}>{center}</Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default KnowledgeBaseLayout;